import {IStateParamsService} from 'angular-ui-router';

let isEmpty = require('lodash/isEmpty');
import {Component, Inject, Output, EventEmitter, Input} from 'ng-metadata/core';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {FacetService} from './facet.service';
import {SearchService} from '../search.service';
import {PrimolyticsService, beacon} from '../../analytics/primolytics.service';
import {MediaQueries} from '../../infra/mediaQueries.service';
import {PersonalizeResultsButtonService} from '../personalization/personalizationButton/personalizeResultsButton.service';
import {SharedSessionStorage} from '../../infra/sharedSessionStorage.service';
import {JournalsService} from '../../journals/journals.service';
import {JwtUtilService} from '../../security/jwtUtil.service';
import {DatabasesService} from "../../journals/databases.service";
import {NewspapersService} from '../../newspapers/newspapers.service';
import {getAttributesMap, getVid, isNgrs, getDefaultScope} from "../../appConfig/appConfigForward";
import {ChangeLangService} from "../../infra/lang/changeLang.service";
import {OrgListCategorizeService} from '../../journals/orgListCategorize/orgListCategorize.service';
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";
import {DatabasesCategorizeService} from "../../journals/databasesCategorize/databasesCategorize.service";
import {OrganizationOrFacetToggleService} from '../../journals/organizationOrFacetToggle/organization-or-facet-toggle.service';
import {WindowInfoUtils} from '../../nddUtils/windowInfoUtils.service';

const get = require('lodash/get');


const forEach = require('lodash/forEach');
const isArray = require('lodash/isArray');
const CITED_BY_FACET_ADDED = ['citedby,exact', 'citing,exact'];
const isEqual = require('lodash/isEqual');

@Component({
    'selector': 'prm-facet',
    templateUrl: 'components/search/facet/facet.html'
})

export class PrmFacet {
    public updateSortBy: Function;

    /* private members */
    private facetInclude: any;
    private facetExclude: any;

    private _showPcAvailability: boolean;
    private _showSearchInFulltext: boolean;
    private _showUIBlocker = false;
    @Output() private closeMobileFacetEvent = new EventEmitter();
    @Input() private categoriesType: string;
    private vid = getVid();
    private haveOrgListCategories = true;
    private _showMobileFacets = true;
    private showTimer;
    private isConfigJournalCategories: boolean = false;

    private KEY_CODE = {
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        TAB: 9,
    };

    constructor(@Inject('$mdSidenav') private $mdSidenav: angular.material.ISidenavService,
                private searchService: SearchService,
                private facetService: FacetService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                private primolyticsService: PrimolyticsService,
                private windowInfoUtils: WindowInfoUtils,
                private mediaQueries: MediaQueries,
                @Inject('$state') private $state: angular.ui.IStateService,
                @Inject('$stateParams') private $stateParams: IStateParamsService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private personalizeResultsButtonService: PersonalizeResultsButtonService,
                private sharedSessionStorage: SharedSessionStorage,
                private jwtUtilService: JwtUtilService,
                private journalsService: JournalsService,
                private databasesService: DatabasesService,
                private configurationUtil: ConfigurationUtil,
                @Inject('$scope') private $scope: ng.IScope,
                private newspapersService: NewspapersService,
                private changeLangService: ChangeLangService,
                private databasesCategorizeService: DatabasesCategorizeService,
                private orgListService: OrgListCategorizeService,
                private organizationOrFacetService: OrganizationOrFacetToggleService) {


        this.facetInclude = {};
        this.facetExclude = {};
        this.facetService.multiResults = [];
        this.facetService.activeMultipleFacets = false;
        this.facetService.activeRangeMultiFacet = false;
        this.setShowPcAvailability();
        this.setShowSearchInFulltext();
        this.pcAvailability = $stateParams['pcAvailability'] === 'true' || false;

        let deregisterShowUIBlockerWatcher = this.$scope.$watch(() => this.searchInProgress, (newVal) => {
            if (newVal) {
                this._showUIBlocker = true;
            } else {
                this.$timeout(() => {
                    this._showUIBlocker = false;
                     deregisterShowUIBlockerWatcher();
                }, 0);
            }
        });

        let deregisterShowTimerWatcher = this.$scope.$watch(() => this.searchInProgress, (newVal) => {
            if (!newVal) {
                this.$timeout(() => {
                    this.showTimer = true;
                    deregisterShowTimerWatcher();
                }, 0);
            }
        });
        this.isConfigJournalCategories = this.setJournalCategoriesByConfiguration();

    };

    ngOnInit() {
    }

    private get searchInProgress() {
        return this.searchService.isSearchInProgress();
    }

    isRapido() {
        return isNgrs();
    }

    private notLocal() {
        return !this.searchService.IsScopeLocal();
    }

    /* getters & setters */
    get facets() {
        return this.facetService.getResults();
    };

    get resultsExists() {
        return !(isEmpty(this.searchService.getResultObject().info));
    };

    get totalResults() {
        if (this.resultsExists) {
            return this.searchService.getResultObject().info.total;
        } else {
            return 0;
        }
    };

    public isFiltered() {
        let options = this.searchService.getSearchObject();
        return options.facets ? options.facets.length > 0 : false;
    }

    get sortby() {
        return this.searchService.getSearchObject().sortby;
    }


    set sortby(sortby) {
        this.searchService.getSearchObject().sortby = sortby;
    }


    public toggleAllFacets() {
        this.$mdSidenav('facets-sidenav-right')
            .toggle();
    }

    @beacon({'p': 'refine', 'op': 'SearchCDIFullText'})
    public runBeacon() {
    }

    public changeSearchInFulltext() {
        this.runBeacon();
		if(this.configurationUtil.isSuprima()){
			this.facetService.updateScope2FtMap(this.calcScope());
		}
        this.searchService.performSearchInFulltextSearch();

        if (this.windowInfoUtils.isMobile()) {
            this.closeMobileFacet();
        }
    }

    @beacon({'p': 'refine', 'op': 'expandResults'})
    public changePcAvailability() {
        let mode = this.pcAvailability ? 'true' : 'false';
        this.$location.search('pcAvailability', mode);
    }

    /*
     * If pc Availability mode option displayed (Include Results with no full-text is not checked in BO)
     * User has the possibility to expand the result, that means by default the result are limited, pcAvailabilityMode is false
     * If pc Availability mode option is hidden (Include Results with no full-text is checked in BO)
     * User does not have the possibility to expand the result because the result are already expanded, pcAvailabilityMode is false
     */
    private setShowPcAvailability() {
        this.showPcAvailability = this.isNotValidState() ? false : this.facetService.showPcAvailabilityForScope(this.calcScope());
    }

    private setShowSearchInFulltext() {
        this.showSearchInFulltext = this.isNotValidState() ? false : this.facetService.showSearchInFullTextForScope(this.calcScope());
    }

    private isNotValidState() {
        return this.isJournalSearch() || this.isDBSearch() || this.isBrowseMode;
    }

    private calcScope() {
        let scope = this.$stateParams['search_scope'] ? this.$stateParams['search_scope'] : getDefaultScope();
        if (this.$state.current.name === STATE_NAMES.NEWSPAPERS) {
            scope = this.configurationUtil.isSuprima() ? "CentralIndex" : "PC";
        }
        return scope;
    }

    public showExpandMyResultsBtn() {
        return this.showPcAvailability && !this.isRapido() && !this.searchInProgress;
    }

    public showSearchInFulltextBtn() {
        return this.isEndUserSelectionEnabledInPrimo && this.showSearchInFulltext && !this.searchInProgress;
    }

    get showPcAvailability() {
        return this._showPcAvailability;
    }

    set showPcAvailability(showPcAvailability) {
        this._showPcAvailability = showPcAvailability;
    }

    get showSearchInFulltext() {
        return this._showSearchInFulltext;
    }

    set showSearchInFulltext(showSearchInFulltext) {
        this._showSearchInFulltext = showSearchInFulltext;
    }


    get pcAvailability() {
        return this.facetService.pcAvailability;
    }

    set pcAvailability(pcAvailability) {
        this.facetService.pcAvailability = pcAvailability;
    }

    get searchInFulltext() {
        return this.facetService.searchInFulltext;
    }

    set searchInFulltext(bool) {
        this.facetService.searchInFulltext = bool;
    }

    get isEndUserSelectionEnabledInPrimo() {
        return this.facetService.isEndUserSelectionEnabledInPrimo();
    }

    public showFacetSection() {
        // the $stateParams can be either "journals" or "databases" but not both
        if (this.$stateParams["journals"] || this.$stateParams["databases"]) {
            let conditionIndication = this.$stateParams["journals"] || this.$stateParams["databases"];
            return conditionIndication.split(",")[0] != "letter";
        } else if (this.isOrgListSearch()) {
            return !this.isShowingOrganizationTree();
        } else {
            return true;
        }
    }

    public isShowFetchMoreResultButton() {
        let info = this.searchService.getResultObject().info;
        return this.resultsExists && info.total < info.maxTotal;
    }

    public fetchMoreResults() {
        let args = this.searchService.getSearchObject();
        args.getMore = 1;
        args.offset = 0;
        this.searchService.search(args, true);
    }

    get isBrowseMode() {
        return this.$stateParams['mode'] === 'browse';
    }

    public personalizationToggled() {
        return this.personalizeResultsButtonService.personalizationToggled();
    }

    public getPersonalization() {
        return this.sharedSessionStorage.getItem('personalization').split(';');
    }

    @beacon({'p': 'personalizedResults', 'op': 'updated'})
    public removeDiscipline(discipline) {
        let personalizationArr = this.sharedSessionStorage.getItem('personalization').split(';');
        let index = personalizationArr.indexOf(discipline);
        if (index > -1) {
            personalizationArr.splice(index, 1);
            if (personalizationArr.length > 0) {
                this.sharedSessionStorage.setItem('personalization', personalizationArr.join(';'));
            } else {
                //If the user removes the last item, clear the storage
                this.sharedSessionStorage.removeItem('personalization');
                this.sharedSessionStorage.removeItem('recentness');
                this.sharedSessionStorage.removeItem('enable_personalization');
                this.personalizeResultsButtonService.enable = false;
                this.personalizeResultsButtonService.recentness = false;
            }
            this.personalizeResultsButtonService.addCameFromPersonalizationParam();
            this.$state.go(STATE_NAMES.SEARCH, this.personalizeResultsButtonService.searchParams, {reload: true});
            if (this.isSignedIn()) {
                this.personalizeResultsButtonService.setUserPersonalizationPreferencesToDB(this.$stateParams['vid']);
            }
        }
    }

    get recentness() {
        return this.personalizeResultsButtonService.recentness;
    }

    @beacon({'p': 'personalizedResults', 'op': 'updated'})
    set recentness(recentness) {
        this.sharedSessionStorage.setItem('recentness', '' + recentness);
        this.personalizeResultsButtonService.recentness = recentness;
        if (this.isSignedIn()) {
            this.personalizeResultsButtonService.setUserPersonalizationPreferencesToDB(this.$stateParams['vid']);
        }
        this.personalizeResultsButtonService.addCameFromPersonalizationParam();
        this.$state.go(STATE_NAMES.SEARCH, this.personalizeResultsButtonService.searchParams, {reload: true});
    }

    public isSignedIn() {
        return this.jwtUtilService.isSignedIn();
    }

    public edit() {
        this.personalizeResultsButtonService.editPressed = true;
        this.personalizeResultsButtonService.cancelPressed = false;
        this.closeMobileFacetEvent.emit({event: event});
    }

    public showPersonalizationSection() {
        if (this.journalsService.isJournalSearch() || this.databasesService.isDBSearch() || this.$state.current.name === STATE_NAMES.CITATION_TRAILS ||
            this.$stateParams ['mode'] === 'browse') {
            return false;
        }
        return true;
    }

    get activeMultipleFacets() {
        if (this.detectMobile()) {
            return 1;
        }
        return this.facetService.totalMultipleResults();
    };

    private clearMultiFacets() {
        this.facetService.clearMultiFacets();
    }

    private applyMultiFacets() {
        this.facetService.applyMultiFacets();
        let isFirst = 1;
        forEach(this.facetService.multiResults, (facet) => {
            facet.operation = 'add';
            if (!isFirst) {
                facet.ignoreInActions = 1;
            }
            this.beaconForMultiFacets(facet);
            isFirst = 0;
        });
        this.closeMobileFacet();
    }

    @beacon({'p': 'refine'})
    public beaconForMultiFacets(facet) {
    }

    private detectMobile() {
        if (this.mediaQueries.xs || this.mediaQueries.sm) {
            return true;
        }
        return false;
    }

    private get showUIBlocker() {
        return this._showUIBlocker;
    }

    private get isNewspapersSearch(): boolean {
        return this.newspapersService.isNewspapersSearch();
    }

    public isDBSearch() {
        return this.databasesService.isDBSearch();
    }

    public isJournalSearch() {
        return this.journalsService.isJournalSearch();
    }

    private isSearchDone() {
        return this.searchService.isSearchDone();
    }

    public isShowPartsOnCitationTrails() {
        let state = this.$state.current.name;
        const facets = this.$stateParams['facet'];
        let checkForCitedBy = facet => facet !== undefined && CITED_BY_FACET_ADDED.some((citedByPrefix => facet.startsWith(citedByPrefix)));
        let citedByFacetExists = isArray(facets) ? facets.some(checkForCitedBy) : checkForCitedBy(facets);
        return state === STATE_NAMES.CITATION_TRAILS || citedByFacetExists;
    }

    public isOrgListSearch() {
        return this.orgListService.isOrgListSearch();
    }

    public isShowingOrganizationTree() {
        //false - will show the facet
        return this.organizationOrFacetService.isOrganizationTree;
    }


    public onSearchBarSearchEvent(eventData) {
        let stateName = STATE_NAMES.SEARCH;
        if (this.journalsService.isJournalSearch() || this.journalsService.returnToJournalsSearch()) {
            stateName = STATE_NAMES.JOURNAL_SEARCH;
        }
        if (this.databasesService.isDBSearch()) {
            stateName = STATE_NAMES.DB_SEARCH;
        }

        if (this.orgListService.isOrgListSearch()) {
            stateName = STATE_NAMES.ORGANIZATION_LIST;
        }

        let params = {
            search_scope: eventData.scopeField,
            tab: eventData.tab,
            journals: eventData.journals,
            databases: eventData.databases,
            organization: eventData.organization,
            organizationPath: eventData.organizationPath,
            sortby: eventData.sortby,
            query: 'contains,' + eventData.searchType + ',',
            vid: this.vid,

        };

        if (angular.isDefined(eventData.offset)) {
            params.offset = eventData.offset;
        }

        this.$state.go(stateName, params, {reload: stateName});

    }


    get isJournalCategories(): boolean {
        return this.databasesCategorizeService.isCategories('journal');
    }

    get isDBCategories(): boolean {
        return this.databasesCategorizeService.isCategories('db');
    }

    get displayDBCategories() {
        return ((this.isDBSearch() && this.isDBCategories)
                || (this.isJournalSearch() && this.isPrimoVE && this.isConfigJournalCategories && this.isJournalCategories))
            && this.isSearchDone();
    }

    public setHaveOrgListCategories(haveOrgListCategories) {
        this.haveOrgListCategories = haveOrgListCategories;
    }

    public getRemoveLabel() {
        return this.$translate.instant('pyr.discipline.removeDiscipline');
    }

    public getDiscipline(discipline: string) {
        return this.$translate.instant('pyr.discipline.' + discipline);
    }

    private closeMobileFacet() {
        this.showMobileFacets = true;
    }

    get showMobileFacets(): boolean {
        return this.searchService.showMobileFacets;
    }

    set showMobileFacets(value: boolean) {
        this.searchService.showMobileFacets = value;
    }

    private pageRtlDirection() {
        return this.changeLangService.direction == 'rtl'
    }

    get isPrimoVE() {
        return this.configurationUtil.getBackendSystem() === 'suprima';
    }

    private setJournalCategoriesByConfiguration() {
        return get(getAttributesMap(), ['journalCategoriesTree'], true);
    }

    private isFromEsploro() {
        return this.searchService.fromEsploro() && this.isPrimoVE;
    }

    public closeMobileFacets() {
        this.searchService.openCloseMobileFacets();
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/components/search/facet/facet.directive.ts